export const SET_USER_LOCATION = 'SET_USER_LOCATION';
export const SET_LIVE_ORDER = 'SET_LIVE_ORDER';